import React, { useState } from 'react';
import Card from '../../components/Card';
import { ImagePlus, Link, Globe, Clock, Users, AlertCircle, ChevronDown, Check, X } from 'lucide-react';
import { adTypes, userSegments, countries } from "../../data";
import CustomSelect from '../../components/CustomSelect.tsx';
import CustomImageUpload from '../../components/CustomImageUpload.tsx';
import { InputField, TextAreaField } from '../../components/InputField';
import ScheduleAndTargeting from "../../components/ScheduleTarget.tsx";
import LaunchAd from "../../components/LaunchAd.tsx";

export default function CreateAd() {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        link: '',
        adType: adTypes[0],
        startDate: '',
        endDate: '',
        userSegment: userSegments[0],
        allowedCountries: [countries[0]],
        activeHours: { start: '09:00', end: '17:00' },
        allowPublish: false,
        image: null as File | null,
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <div className="pb-8 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            

            <form onSubmit={handleSubmit} className="space-y-8">
                <Card className="p-8 rounded-3xl border border-indigo-50 bg-gradient-to-br from-white to-indigo-50 shadow-lg">
                    <div className="space-y-8">
                        {/* Basic Information Section */}
                        <section className="space-y-6">
                            <div className="pb-4 border-b border-indigo-100">
                                <h2 className="text-xl font-semibold flex items-center">
                                    <span className="bg-gradient-to-r from-indigo-600 to-purple-600 w-9 h-9 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                        <Globe size={20} className="text-white" />
                                    </span>
                                    <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                                        Campaign Details
                                    </span>
                                </h2>
                            </div>

                            <div className="grid md:grid-cols-2 gap-8">
                                <InputField
                                    label="Campaign Title"
                                    value={formData.title}
                                    onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                                    placeholder="Summer Sale Campaign"
                                    className="border-2 border-indigo-100 focus:ring-2 focus:ring-indigo-500"
                                />
                                <InputField
                                    label="Destination URL"
                                    type="url"
                                    value={formData.link}
                                    onChange={(e) => setFormData(prev => ({ ...prev, link: e.target.value }))}
                                    placeholder="https://example.com/offer"
                                    icon={Link}
                                    iconClassName="text-indigo-400"
                                    className="pl-11 border-2 border-indigo-100 focus:ring-2 focus:ring-indigo-500"
                                />
                                <TextAreaField
                                    label="Campaign Description"
                                    value={formData.description}
                                    onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                                    placeholder="Describe your campaign..."
                                    className="border-2 border-indigo-100 focus:ring-2 focus:ring-indigo-500"
                                />
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-indigo-900">Ad Format</label>
                                    <CustomSelect
                                        options={adTypes}
                                        selected={formData.adType}
                                        onChange={(adType) => setFormData(prev => ({ ...prev, adType }))}
                                        placeholder="Select ad type"
                                        className="border-2 border-indigo-100 hover:border-indigo-200 rounded-xl"
                                    />
                                </div>
                                <div className="md:col-span-2 space-y-2">
                                    <label className="text-sm font-medium text-indigo-900">Creative Asset</label>
                                    <CustomImageUpload
                                        onFileChange={(file) => setFormData(prev => ({ ...prev, image: file }))}
                                        currentFile={formData.image}
                                        dropzoneClass="border-2 border-dashed border-indigo-100 hover:border-indigo-200"
                                    />
                                </div>
                            </div>
                        </section>

                        <ScheduleAndTargeting
                            formData={formData}
                            setFormData={setFormData}
                            userSegments={userSegments}
                            countries={countries}
                        />

                        <LaunchAd formData={formData} setFormData={setFormData} />
                    </div>
                </Card>

                {/* Form Actions */}
                <div className="flex justify-end gap-4">
                    <button
                        type="button"
                        onClick={() => window.history.back()}
                        className="px-6 py-3 text-indigo-600 bg-white border-2 border-indigo-100 rounded-xl hover:bg-indigo-50 transition-all shadow-sm hover:shadow-md"
                    >
                        Discard
                    </button>
                    <button
                        type="submit"
                        className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl hover:scale-[1.02]"
                    >
                        Launch Campaign
                    </button>
                </div>
            </form>
        </div>
    );
}